import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  presignedS3Url(data) {
    return api.post(`/api/v1/s3/presigned-url`, data);
  },
};
